"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _ButtonBase = _interopRequireDefault(require("@material-ui/core/ButtonBase"));

var _color = _interopRequireDefault(require("color"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    //        minHeight: theme.spacing(7),
    padding: theme.spacing(.5),
    "& > *": {}
  },
  swatch: {
    boxShadow: theme.shadows[1],
    minHeight: theme.spacing(3),
    minWidth: theme.spacing(3),
    margin: theme.spacing(.5),
    backgroundColor: props => {
      return props.backgroundColor;
    },
    color: props => {
      return props.color;
    },
    borderRadius: "100%",
    display: "flex",
    flexAlign: "center",
    justifyContent: "center"
  },
  label: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: '1em',
    fontWeight: "bold",
    lineHeight: '1'
  }
}));

const ColorSwatches = ({
  variant,
  backgroundColor,
  colors = [],
  color,
  onChange
}) => {
  const classes = useStyles();

  const handleChange = (hex, event) => {
    onChange && onChange({
      hex: hex
    }, event);
  };

  if (!colors.length) {
    return false;
  }

  const SwatchButton = ({
    color,
    contrastColor,
    onClick
  }) => {
    if (variant === "text") {
      backgroundColor = backgroundColor || contrastColor;
    } else {
      backgroundColor = color;
      color = contrastColor;
    }

    const classes = useStyles({
      backgroundColor: backgroundColor,
      color: color
    });
    return _react.default.createElement(_ButtonBase.default, {
      className: classes.swatch,
      onClick: onClick
    }, _react.default.createElement("i", {
      className: classes.label
    }, "A"));
  };

  return _react.default.createElement("div", {
    className: classes.root,
    "data-size": colors.length
  }, colors.map((color, index) => {
    const primaryColor = (0, _color.default)(color);
    const contrastColor = primaryColor.isLight() && "black" || "white";
    return _react.default.createElement(SwatchButton, {
      color: color,
      contrastColor: contrastColor,
      key: index,
      onClick: event => handleChange(color, event)
    });
  }));
};

var _default = ColorSwatches;
exports.default = _default;
module.exports = exports.default;